var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeclareHomeLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.672,
    height: 21.919,
    viewBox: "0 0 20.672 21.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#479ed5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.507 -4583.793)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.107,4588.175a1.353,1.353,0,0,1,1.351-1.352h4.257v-1.4h-4.257a2.756,2.756,0,0,0-2.751,2.753v4.257h1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.107,4602.96V4598.7h-1.4v4.257a2.756,2.756,0,0,0,2.751,2.753h4.257v-1.4h-4.257A1.353,1.353,0,0,1-370.107,4602.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-353.448,4602.96a1.353,1.353,0,0,1-1.351,1.352h-4.257v1.4h4.257a2.756,2.756,0,0,0,2.752-2.753V4598.7h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-358.291,4595.182a.65.65,0,0,0-.65-.651h-2.1v-2.1a.65.65,0,0,0-.65-.651.65.65,0,0,0-.65.651v2.1h-2.1a.65.65,0,0,0-.65.651.65.65,0,0,0,.65.65h2.1v2.1a.65.65,0,0,0,.65.65.65.65,0,0,0,.65-.65v-2.1h2.1A.65.65,0,0,0-358.291,4595.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-357.978,4592.91h1.53V4589.8h2.7v3.111h1.489v-4.834h1.421l-4.282-4.282-4.282,4.282h1.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclareHomeLocker);
export default __webpack_public_path__ + "static/media/declareHomeLocker.cde2337c457b4651bfe5310216e79b95.svg";
export { ForwardRef as ReactComponent };